import { NgModule, APP_INITIALIZER  } from '@angular/core';
import { BrowserModule }  from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
// import { SplashComponent } from '../splash/splash.component';
// import { DashboardComponent } from '../dashboard/dashboard.component';
import { HttpModule } from '@angular/http';
import { routing} from './app.routing';
// import { PlanningToolDash } from '../planningtool/planning-tool-dashboard';
import { ViewsModule } from '../viewsmodule/views.module';
// import { IntroModule } from '../intro/intro.module';

import { AuthGuard } from '../_guards/auth.guard'
import { Utils } from '../utils/utils';
import { ConnectModule } from '../connect/connect.module';
import { DataService } from '../services/data.service';
import { ConfigurationService } from '../services/configuration.service';
import { AppConfig } from './app.config';
//import { TabsModule, ButtonsModule, DropdownModule, ModalModule, CarouselModule, TooltipModule, AccordionModule } from 'ng2-bootstrap/ng2-bootstrap';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        HttpModule,
        routing,
        ViewsModule,
        // IntroModule,
        ConnectModule
    ],
    declarations: [
        AppComponent
    ],
    providers: [ 
        AuthGuard, 
        Utils, 
        DataService,
        ConfigurationService,
        AppConfig,
        { provide: APP_INITIALIZER, useFactory: (config: AppConfig) => () => config.load(), deps: [AppConfig], multi: true }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/boot/app.module.ts